import { Store } from "react-notifications-component";

// The app's standard top-right confirmation toast.
export const notifySuccess = (message) =>
  Store.addNotification({
    title: "Agtuall",
    message,
    type: "success",
    insert: "top",
    container: "top-right",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 3000,
      onScreen: true,
    },
  });
